import Vue from 'vue';

// import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import {
  BadgePlugin, CarouselPlugin, CollapsePlugin, DropdownPlugin, NavPlugin, NavbarPlugin, ProgressPlugin,
} from 'bootstrap-vue';

Vue.use(BadgePlugin);
Vue.use(CarouselPlugin);
Vue.use(CollapsePlugin);
Vue.use(DropdownPlugin);
Vue.use(NavPlugin);
Vue.use(NavbarPlugin);
Vue.use(ProgressPlugin);
